import React, { useContext, useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import moment from "moment";
import { Rating } from "primereact/rating";
import { Tag } from "primereact/tag";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../services/store/userSlice";
import { FileUpload } from "primereact/fileupload";
import { InputTextarea } from "primereact/inputtextarea";
import { timesheetApi, trainingApi } from "../../services";
import { professionalService, skillService } from "../../services/profile";
import { AutoComplete } from "primereact/autocomplete";
import { useFormik } from "formik";
import { Checkbox } from "primereact/checkbox";
import { toast } from "react-toastify";
import { Dialog } from 'primereact/dialog';
import UserRatingDetailView from './user-rating-detail-view';
import { Calendar } from "primereact/calendar";
import { projectStatusOfResource } from '../../common/util/constants';

export default function Training({ parent = false, setNewTrf, setScreen, reload, trainingData = {}, mode = {}, closeTrainingDialog, skillValidationData }) {
  const user = useSelector(selectUser);
  const [userRole, setUserRole] = useState("");
  const navigate = useNavigate();
  const [employeeName] = useState("Khyati Gupta");
  const [selectedTraining, setSelectedTraining] = useState("N");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [userProfileDetails, setUserProfileDetails] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [trainingCategory, setTrainingCategory] = useState([]);
  const job = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ];

  const [skills, setSkills] = useState([
    { skill: "React", rating: 4, experience: "3 years" },
    { skill: "Node.js", rating: 3, experience: "2 years" },
  ]);
  const [newSkill, setNewSkill] = useState("");
  const [rating, setRating] = useState(null);
  const [gapIdentification, setGapIdentification] = useState("");
  const [onJobTrainingRequired, setOnJobTrainingRequired] = useState(null);
  const [targetSkill, setTargetSkill] = useState("");
  const [hours, setHours] = useState("");
  const [comments, setComments] = useState("");
  const [formLink, setFormLink] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [skillData, setSkillData] = useState([]);
  const [filteredSkills, setFilteredSkills] = useState(null);
  const [ratingOptions, setRatingOptions] = useState([]);
  const [ratingTableStatus, setRatingTableStatus] = useState(false);
  const [currentProject, setCurrentProject] = useState([]);
  const [currentstatus, setCurrentstatus] = useState([]);
  const loggedInUser = useSelector(selectUser);
  
    const [filteredSkill, setFilteredSkill] = useState(null);

  const [nominatedEmployeeDetails, setNominatedEmployeeDetails] = useState(null);


  const formik = useFormik({
    initialValues: {
      requesterName: loggedInUser?.firstName + " " + loggedInUser?.lastName,
      requesterEcn: loggedInUser?.ecn,
      requesterBu: "BU-" + loggedInUser?.businessUnitId,
      requisitionDate: new Date(),
      trainingCategory: null,
      targetSkill: null,
      nominatedParticipant: null,
      resourceCurrentProject: null,
      resourceProjectStatus: null,
      resourceCurrentTech: "",
      trainingEndDate: "",
      improvmentAreaComment: "",
      moduleDetails: "",
      NoOfHours: "",
      // skillsetLevel: "",
      // reqTrainingPurpose: []
    },
    validate: (data) => {
      let errors = {};
      if (!data.nominatedParticipant) errors.nominatedParticipant = 'Participant Name is required.';
      if (!data.targetSkill) errors.targetSkill = 'Target Skill is required.';
      if (!data.improvmentAreaComment) errors.improvmentAreaComment = 'Triggering Area is required.';
      if (!data.moduleDetails) errors.moduleDetails = 'Details is required.';
      if (!data.resourceCurrentTech) errors.resourceCurrentTech = 'Current Tech. is required.';
      if (selectedTraining === "Y") {
        if (!data.resourceCurrentProject) errors.resourceCurrentProject = 'Project is required.';
        if (!data.resourceProjectStatus) errors.resourceProjectStatus = 'Resource Status is required.';
        if (!data.trainingCategory) errors.trainingCategory = "Category is required";
        if (!data.trainingEndDate) errors.trainingEndDate = 'End Date is required.';
        if (!data.NoOfHours) errors.NoOfHours = 'No. Of Hours is required.';
      }
      return errors;
    },
    onSubmit: (data) => {
      if (selectedTraining === "N") {
        setScreen('new');
        updateSkillData();
      } else {
        let trfPayload = {
          "userId": nominatedEmployeeDetails?.id,
          "nameOfRequester": data?.requesterName,
          "ecnOfRequester": data?.requesterEcn,
          "businessUnit": data?.requesterBu,
          "startDate": moment(data?.requisitionDate).format("YYYY-MM-DD"),
          "categoryOfTraining": data?.trainingCategory,
          "targetSkill": data?.targetSkill?.id,
          "targetSkillName": data?.targetSkill?.title,
          "nameOfNominatedParticipant": data?.nominatedParticipant?.name,
          "currentStatusOfNominatedResource": data?.resourceProjectStatus,
          "projectName": data?.resourceCurrentProject,
          "currentTechnology": data?.resourceCurrentTech,
          "endDate": moment(data?.trainingEndDate).format("YYYY-MM-DD"),
          "trainingLearning": data?.improvmentAreaComment,
          "learningApplyOnProject": data?.moduleDetails,
          "NoOfHours": data?.NoOfHours,
          "OnJobTrainingRequire": true,
          "trainingType": "Self-Paced",
        }
        // CreateUserTrfFormm(trfPayload);
        try {
              trainingApi.createTraining(trfPayload).then(
                (resp) => {
                  toast.success(resp?.data?.message);
                  setTimeout(() => {
                    setNewTrf(false);
                    reload();
                    setScreen('listing');
                  }, 1000);
                },
                (err) => {
                  toast.error(err.response.data.error);
                }
              );
            } catch (error) {
              toast.error("Unable to update");
            }
      }
    },
  });

  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };


  // const searchSkill = (event) => {
  //   setTimeout(() => {
  //     let _filteredSkills;
  //     if (!event.query.trim().length) {
  //       _filteredSkills = [...skillData];
  //     } else {
  //       _filteredSkills = skillData.filter((p) => {
  //         if (p.title !== null) {
  //           return p.title.toLowerCase().startsWith(event.query.toLowerCase());
  //         }
  //       });
  //     }
  //     setFilteredSkills(_filteredSkills);
  //   }, 250);
  // };

  const searchSkill = (event) => {
    setTimeout(() => {
      let _filteredSkill;
      if (!event.query.trim().length) {
        _filteredSkill = [...skillList];
      } else {
        _filteredSkill = skillList.filter((p) => {
          if (p.title !== null) {
            return p.title.toLowerCase().startsWith(event.query.toLowerCase());
          }
        });
      }
      setFilteredSkill(_filteredSkill);
    }, 250);
  };

  const get_skills = () => {
    skillService.getSkills().then((resp) => {
      setSkillData(resp.data.data);
      setSkillList(resp.data.data);
    });
  };
  // const targetSkills = ["React", "Node.js", "JavaScript", "Python"];
  // const values = [{ label: "Space used", value: 15 }];
  const handleAddSkill = () => {
    setSkills([...skills, { skill: newSkill, rating: 0, experience: "" }]);
    setNewSkill("");
  };

  useEffect(() => {
    setUserRole(user.UserRoles[0].Role.role_name);
    get_skills();
    fetchRatings();
    fetchCategories();
    getManagerUserInfo({ pageNum: 0, pageSize: 40 });
  }, []);

  const fetchCategories = () => {
    trainingApi.fetchTrainingCategoryList().then((resp) => {
      setTrainingCategory(resp.data.data);
    });
  };

  // useEffect(() => {
  //  if(mode) {
  //   formik.setFieldValue("trainingid", trainingData?.id);
  //   formik.setFieldValue("targetSkill", trainingData?.targetSkills);
  //   formik.setFieldValue("projectName", trainingData?.projectName);
  //   formik.setFieldValue("categoryOfTraining", trainingData?.categoryOfTrainings?.title);
  //   formik.setFieldValue("trainingType", trainingData?.trainingType);
  //   formik.setFieldValue("startDate", trainingData?.startDate);
  //   formik.setFieldValue("endDate", trainingData?.endDate);
  //   formik.setFieldValue("progressUpdate", trainingData?.progressUpdate);
  //   formik.setFieldValue("trainingLearning", trainingData?.trainingLearning);
  //   formik.setFieldValue(
  //     "learningApplyOnProject",
  //     trainingData?.learningApplyOnProject
  //   );
  //  }
  // }, [mode]);
  useEffect(() => {
    // formik.setFieldValue("trainingid", trainingData?.id);
    // formik.setFieldValue("targetSkill", trainingData?.targetSkills);
    // formik.setFieldValue("projectName", trainingData?.projectName);
    // formik.setFieldValue("categoryOfTraining", trainingData?.categoryOfTrainings?.title);
    // formik.setFieldValue("trainingType", trainingData?.trainingType);
    // formik.setFieldValue("startDate", trainingData?.startDate);
    // formik.setFieldValue("endDate", trainingData?.endDate);
    // formik.setFieldValue("progressUpdate", trainingData?.progressUpdate);
    // formik.setFieldValue("trainingLearning", trainingData?.trainingLearning);
    // formik.setFieldValue(
    //   "learningApplyOnProject",
    //   trainingData?.learningApplyOnProject
    // );
  }, []);

  useEffect(() => {
    if (user?.id) {
      getEmployeeDetails(user.id);
    }
  }, []);

  const fetchRatings = () => {
    trainingApi.getRatings().then((resp) => {
      resp.data.data.sort((a, b) => a.code - b.code);
      setRatingOptions(resp.data.data);
    });
  };

  const getEmployeeDetails = (id) => {
    professionalService.getUserProfileDetails(id).then((resp) => {
      setCurrentUser(resp.data.data);
      if (resp?.data?.data?.TrainingDetails) {
        var dataObj = resp?.data?.data?.TrainingDetails[0];
        formik.setFieldValue("trainingid", dataObj?.id);
        formik.setFieldValue("targetSkill", "");
        formik.setFieldValue("projectName", dataObj?.projectName);
        formik.setFieldValue("categoryOfTraining", dataObj?.categoryOfTrainings?.title);
        formik.setFieldValue("trainingType", dataObj?.trainingType);
        formik.setFieldValue("startDate", dataObj?.startDate);
        formik.setFieldValue("endDate", dataObj?.endDate);
        formik.setFieldValue("progressUpdate", dataObj?.progressUpdate);
        formik.setFieldValue("trainingLearning", dataObj?.trainingLearning);
        formik.setFieldValue(
          "learningApplyOnProject",
          dataObj?.learningApplyOnProject
        );
      }
    });
  };

  const getManagerUserInfo = (param = {}) => {
    timesheetApi.getUsersBySuperior(param).then((resp) => {
      try {
        // setEmployeeList(resp?.data?.data);
        if (resp?.data?.data.length > 0) {
          const data = resp?.data?.data;
          // const transformedData = data.map((user) => ({
          //   name: `${user.firstName} ${user.lastName}`.trim(),
          //   ecn: user.ecn,
          //   id: user.id,
          // }));
          const transformedData = data?.map((user) => {
            return {
              ...user,
              name: `${user?.firstName} ${user?.lastName}`.trim(),
            }
          });
          setEmployeeList(transformedData);
        }
      } catch (error) {
        // Error handle
      }
    });
  };
  const [checked, setChecked] = useState(false);
  const [business, setBusiness] = useState(false);

  const fetchEmployeeSkills = (e) => {
    setNominatedEmployeeDetails(e.value);
    setSelectedEmployee(e.value);
    getSkillsById(e.value.id);
    fetchEngagement();

    const result = e.target.value.Allocations.map(item => ({ isBillable: item.isBillable, billableTitle: item.isBillable ? 'Billable' : 'Non-Billable', title: item.Project.title }));
    formik.setFieldValue("nominatedParticipant", e.target.value);
    setCurrentProject(result);

    if (e.target.value.Allocations?.length > 0) {
      const firstBillableItem = e.target.value.Allocations.find(item => item.isBillable === true);
      if (firstBillableItem) {
        const filteredBillableStatus = result.filter(item => item.isBillable === true);
        formik.setFieldValue("resourceCurrentProject", firstBillableItem?.Project?.title);
        formik.setFieldValue("resourceProjectStatus", filteredBillableStatus[0]?.billableTitle);
      } else {
        formik.setFieldValue("resourceCurrentProject", result[0]?.title);
        formik.setFieldValue("resourceProjectStatus", result[0]?.billableTitle);
      }
    } else {
      setCurrentProject([]);
    }
  };

  const fetchEngagement = () => {
    trainingApi.getEngagementTypes().then((resp) => {
      setCurrentstatus(resp.data.data);
    });
  };

  const getSkillsById = (id) => {
    trainingApi.fetchSkillsByID(id).then((resp) => {
      try {
        setUserProfileDetails(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };

  const openTRFForm = (e) => {
    e.preventDefault();
    const nominatedEmployeeName = selectedEmployee?.name;
    const targetSkillData = formik.values.skills?.title;
    navigate("/trf", {
      state: { nominatedEmployeeName, targetSkillData },
    });
  };

  const updateTrainingDetails = (e) => {
    // todo
    e.preventDefault();
    const dataObj = {
      emp_name: selectedEmployee,
      training_required: selectedTraining,
      target_skill: formik.values.skills,
      target_ratng: rating,
      gap: formik.values.gapIdentification,
      comments: formik.values.comments,
    };
    toast.success("Updated Successfully");
  };

  const resetTrainingForm = (e) => {
    e.preventDefault();
    formik.resetForm();
    setRating(null);
    setSelectedEmployee(null);
    setSelectedTraining(null);
    setUserProfileDetails([]);
  };

  const handleEmployeeSubmit = (e) => {
    e.preventDefault();
    const dataObj = {
      id: formik.values.trainingid,
      targetSkill: formik.values.targetSkill,
      projectName: formik.values.projectName,
      categoryOfTraining: formik.values.categoryOfTraining,
      trainingType: formik.values.trainingType,
      startDate: formik.values.startDate,
      endDate: formik.values.endDate,
      progressUpdate: formik.values.progressUpdate,
      trainingLearning: formik.values.trainingLearning,
      learningApplyOnProject: formik.values.learningApplyOnProject,
      userId: user.id,
    };
    try {
      trainingApi.updateEmployeeTraining(dataObj).then(
        (resp) => {
          toast.success(resp.data.message);
          setTimeout(() => {
            if (mode === "Edit") closeTrainingDialog()
          }, 1000);
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to update");
    }
  };

  const renderUserSkillDialog = () => {
    return (<>
      <Dialog className='custom_popup' header="User Skill Rating" visible={ratingTableStatus} onHide={() => setRatingTableStatus(false)} style={{ width: '80vw' }}>
        <UserRatingDetailView clickedRowData={selectedEmployee} />
      </Dialog>
    </>)
  }


  const updateSkillData = () => {
    let skillObj = { id: formik.values.targetSkill.id, title: formik.values.targetSkill.title }
    skillValidationData({ nameOfNominatedParticipant: selectedEmployee?.name, userId: selectedEmployee?.id, targetSkills: skillObj, currentTechnology: formik.values.resourceCurrentTech, improvementAreaTriggeringTrainingNeed: formik.values.improvmentAreaComment, moduleSpecificDetails: formik.values.moduleDetails })
  }

  const handleDateChange = (date) => {
    formik.setFieldValue("requisitionDate", date);
    formik.setFieldValue("trainingEndDate", "");
  };

  const handleTrainingDateChange = (date) => {
    formik.setFieldValue("trainingEndDate", date);
  }

  return (
    <div className="container">
      {renderUserSkillDialog()}
      {userRole === "PM" ? (
        <div className="card">
          {!parent && <>
            <div className="grid col-12">
              <div className="col">
                <h1 className="p-0 training-heading">Skill Validation</h1>
              </div>
              <div className="col"></div>
              <div className="p-0" style={{ float: "right", marginTop: "14px" }}>
                <span className="p-input-icon-left">
                  <i className="pi pi-search" />
                  <InputText type="search" placeholder="Search" />
                </span>
              </div>
            </div>
            <hr />
          </>}
          <form onSubmit={formik.handleSubmit} autoComplete='off'>
            <div className="card">
              <div className="flex flex-wrap p-field font-bold block">
              <div className="col-6">
                  <label htmlFor="text" className="font-bold block mb-2 training-heading">
                    On-Job Training Required
                  </label>
                  <Dropdown value={selectedTraining} onChange={(e) => setSelectedTraining(e.value)} options={job} optionLabel="label" placeholder="Training Required" className="w-full" />
                </div>

                <div className="col-6">
                  <label htmlFor="text" className="font-bold block mb-2 training-heading">
                    Employee Name
                  </label>
                  <div className="p-inputgroup flex-1">
                    <span className="p-inputgroup-addon"><i className="pi pi-user"></i></span>
                    <Dropdown name="nominatedParticipant" value={formik.values.nominatedParticipant} onChange={(e) => fetchEmployeeSkills(e)} options={employeeList} filter optionLabel="name" placeholder="Select Employees" className="w-full" />
                  </div>
                  {getFormErrorMessage('nominatedParticipant')}
                </div>
              </div>
            </div>

            {selectedEmployee && (
              <div className="p-field font-bold block">
                <div className="card mt-2 skill-bar">
                  <div className="flex flex-wrap p-field font-bold block">
                    <Button label="View Skill List" title='View Resource Skills' className="p-button-rounded p-button-primary" severity="secondary" type="button" onClick={() => setRatingTableStatus(true)} />
                  </div>
                </div>
              </div>
            )}
            <div className="card mt-2">
              <div className="flex flex-wrap p-field font-bold block">
                <div className="col-6">
                  <label className="mb-4 mt-2 training-heading">
                    Target Skill
                  </label>
                  <div className="mt-2">
                    <div className="p-fluid">
                      {/* <AutoComplete value={formik.values.targetSkill} suggestions={filteredSkills} completeMethod={searchSkill} field="title" name="targetSkill" virtualScrollerOptions={{ itemSize: 38 }} onChange={formik.handleChange} placeholder="Enter your area of Expertise/Specialization" aria-label="Skills" dropdownAriaLabel="Select Skills" /> */}
                      <AutoComplete
                        value={formik.values.targetSkill}
                        suggestions={filteredSkill}
                        completeMethod={searchSkill}
                        field="title"
                        name="targetSkill"
                        // multiple
                        virtualScrollerOptions={{ itemSize: 38 }}
                        onChange={formik.handleChange}
                        placeholder="Enter your area of Expertise/Specialization"
                        aria-label="Skills"
                        dropdownAriaLabel="Select Skills"
                      />
                      {getFormErrorMessage('targetSkill')}
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <label htmlFor="rating" className="mb-4 mt-2 training-heading">
                  Current Technology
                  </label>
                  <div className="mt-2">
                    <InputText name="resourceCurrentTech" value={formik.values.resourceCurrentTech} onChange={(e) => formik.handleChange(e)} placeholder="Enter Current Technology" className="w-full" style={{ background: "#fff" }} />
                  </div>
                  {getFormErrorMessage('resourceCurrentTech')}
                </div>
              </div>
            </div>
            <div className="card mt-2">
              <div className="flex flex-wrap p-field font-bold block">
                <div className="col-6">
                  <label className="mb-4 mt-2 training-heading">
                    Gap Identification
                  </label>
                  <div className="mt-2">
                    <InputText name="improvmentAreaComment" value={formik.values.improvmentAreaComment} onChange={formik.handleChange} placeholder="Describe the skill gap" className="w-full" style={{ backgroundColor: "white" }} />
                    {getFormErrorMessage('improvmentAreaComment')}
                  </div>
                </div>
                <div className="col-6">
                  <label className="mb-4 mt-2 training-heading">
                    Notes/Comments
                  </label>
                  <div className="mt-2">
                    <InputText name="moduleDetails" value={formik.values.moduleDetails} onChange={formik.handleChange} placeholder="Add comments" className="w-full" style={{ backgroundColor: "white" }} />
                    {getFormErrorMessage('moduleDetails')}
                  </div>
                </div>
                {selectedTraining === "Y" && (
                  <>
                    <div className="col-6">
                      <label className="mb-4 mt-2 training-heading">
                        Project Details
                      </label>
                      <div className="mt-2">
                        <Dropdown name="resourceCurrentProject" value={formik.values.resourceCurrentProject} onChange={(e) => formik.handleChange(e)} options={currentProject} optionLabel="title" optionValue="title" placeholder="Select Project" className="w-full" />
                      </div>
                      {getFormErrorMessage('resourceCurrentProject')}
                    </div>

                    <div className="col-6">
                      <label className="mb-4 mt-2 training-heading">
                        Current Status Of Nominated Resource
                      </label>
                      <div className="mt-2">
                        <Dropdown name="resourceProjectStatus" value={formik.values.resourceProjectStatus} onChange={(e) => formik.handleChange(e)} options={projectStatusOfResource} optionValue="title" optionLabel="title" placeholder="Select Status" className="w-full" />
                      </div>
                      {getFormErrorMessage('resourceProjectStatus')}
                    </div>

                    <div className="col-6">
                      <label className="mb-4 mt-2 training-heading">
                        No.of Hours
                      </label>
                      <div className="mt-2">
                        <InputText type="number" value={formik.values.NoOfHours} name="NoOfHours" onChange={formik.handleChange} placeholder="No.of Hours" className="w-full" style={{ backgroundColor: "white" }} />
                        {getFormErrorMessage('NoOfHours')}
                      </div>
                    </div>

                    <div className="col-6">
                      <label className="mb-4 mt-2 training-heading">
                        Catgory of Training
                      </label>
                      <div className="mt-2">
                        <Dropdown name="trainingCategory" value={formik.values.trainingCategory} onChange={(e) => formik.handleChange(e)} options={trainingCategory} optionLabel="title" optionValue="id" placeholder="Select a Category" className="w-full" />
                      </div>
                      {getFormErrorMessage('trainingCategory')}
                    </div>

                    <div className="col-6">
                      <label className="mb-4 mt-2 training-heading">
                        Training Requisition Date
                      </label>
                      <div className="mt-2">
                        <Calendar name="requisitionDate" value={formik.values.requisitionDate} onChange={(e) => handleDateChange(e.target.value)} minDate={new Date()} placeholder="Select Date" showIcon className="w-full requisition-date" />
                      </div>
                    </div>

                    <div className="col-6">
                      <label className="mb-4 mt-2 training-heading">
                        End Date for Training
                      </label>
                      <div className="mt-2">
                        <Calendar name="trainingEndDate" value={formik.values.trainingEndDate} onChange={(e) => handleTrainingDateChange(e.target.value)} minDate={formik.values.requisitionDate ? new Date(new Date(formik.values.requisitionDate).getTime() + 86400000) : new Date()} placeholder="Select Date" showIcon className="w-full requisition-date" />
                      </div>
                      {getFormErrorMessage('trainingEndDate')}
                    </div>
                  </>
                )}
              </div>
            </div>
            {!onJobTrainingRequired && (
              <div className="flex flex-wrap p-field font-bold block">
                <div className="col-6">
                  <label className="training-heading">TRF Form Link</label>
                  <div>
                    <Button
                      label="Open TRF Form"
                      className="p-button-sm mt-2 p-button-primary"
                      disabled={selectedTraining === "N" ? false : true}
                    // onClick={(e) => openTRFForm(e)}
                    // onClick={() => { setScreen('new'); updateSkillData() }}
                    />
                    {selectedTraining === "Y" && (
                      <Button label="Submit" className="p-button-sm mt-2 ml-2 p-button-primary" />
                    )}
                  </div>
                </div>
              </div>
            )}
          </form>

          {/* Notification Section */}
          <div className="flex flex-wrap p-field font-bold block">
            <div className="col-12">
              <h4 className="training-heading">Skills Below 50%</h4>
              <ul>
                {userProfileDetails
                  .filter((skill) => skill?.primarySkillRating < 4)
                  .map((skill, index) => (
                    <li key={index}>
                      {skill?.Skill?.title} - Rating:{" "}
                      {skill?.primarySkillRating ? skill?.primarySkillRating : 0}{" "}
                      <Tag value="Below 50%" severity="danger" />
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      ) : userRole === "Employee" ? (
        <div className="card">
          <div className="grid col-12">
            <div className="col">
              <h1 className="p-0 training-heading">Training Details</h1>
            </div>
            <div className="col"></div>
            <div
              className="p-0"
              style={{ float: "right", marginTop: "14px" }}
            ></div>
          </div>
          <hr></hr>
          <form>
            <div className="card">
              <div className="flex flex-wrap p-field font-bold block">
                <div className="col-6">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Target Skill
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputText
                      name="trainingLearning"
                      value={formik.values.trainingLearning}
                      onChange={formik.handleChange}
                      disabled
                      placeholder="Skills"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Project Name
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputText
                      name="projectName"
                      value={formik.values.projectName}
                      onChange={formik.handleChange}
                      disabled
                      placeholder="Project"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Category Of Training
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputText
                      name="categoryOfTraining"
                      value={formik.values.categoryOfTraining}
                      onChange={formik.handleChange}
                      disabled
                      placeholder="Category"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Training Type
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputText
                      name="trainingType"
                      value={formik.values.trainingType}
                      onChange={formik.handleChange}
                      disabled
                      placeholder="Self Paced"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Start Date
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputText
                      name="startDate"
                      value={formik.values.startDate}
                      onChange={formik.handleChange}
                      disabled
                      placeholder="28-11-2024"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    End Date
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputText
                      name="endDate"
                      value={formik.values.endDate}
                      onChange={formik.handleChange}
                      disabled
                      placeholder="30-11-2024"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Progress Update
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputTextarea
                      name="progressUpdate"
                      value={formik.values.progressUpdate}
                      onChange={formik.handleChange}
                      placeholder="Enter Your Progress"
                      disabled={mode === "View"}
                      rows={7}
                      className="w-full"
                      style={{ background: "#fff" }}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Documents Upload (Only upload .jpg,.jpeg,.png,.pdf)
                  </label>
                  <div className="w-full">
                    <FileUpload
                      name="demo[]"
                      url={"/api/upload"}
                      multiple
                      accept="image/*"
                      maxFileSize={1000000}
                      disabled={mode === "View"}
                      emptyTemplate={
                        <p className="m-0 w-full">
                          Drag and drop files to here to upload.
                        </p>
                      }
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Training Learnings
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputTextarea
                      name="trainingLearning"
                      value={formik.values.trainingLearning}
                      onChange={formik.handleChange}
                      placeholder="Enter Your Learnings"
                      disabled={mode === "View"}
                      rows={4}
                      className="w-full"
                      style={{ background: "#fff" }}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Learning apply on project
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputTextarea
                      disabled={mode === "View"}
                      name="learningApplyOnProject"
                      value={formik.values.learningApplyOnProject}
                      onChange={formik.handleChange}
                      placeholder="Enter Project Name"
                      rows={4}
                      className="w-full"
                      style={{ background: "#fff" }}
                    />
                  </div>
                </div>
                {mode !== "View" &&
                  <div className="col-6">
                    <button
                      aria-label="submit"
                      class="p-button p-component p-button-primary mt-2"
                      type="submit"
                      data-pc-name="button"
                      data-pc-section="root"
                      onClick={handleEmployeeSubmit}
                    >
                      <span
                        class="p-button-icon p-c p-button-icon-left pi pi-check"
                        data-pc-section="icon"
                      ></span>
                      <span
                        className="p-button-label p-c"
                        data-pc-section="label"
                      >
                        Submit{" "}
                      </span>
                    </button>
                  </div>
                }
              </div>
            </div>
          </form>
        </div>
      ) : (
        <div className="card">
          <div className="grid col-12">
            <div className="col">
              <h1 className="p-0 training-heading">Business Outcome </h1>
            </div>
            <div className="col"></div>
            <div
              className="p-0"
              style={{ float: "right", marginTop: "14px" }}
            ></div>
          </div>
          <hr></hr>
          <form>
            <div className="card">
              <div className="flex flex-wrap p-field font-bold block">
                <div className="col-12">
                  <h1 className="p-0 mb-0 training-heading">
                    Training Feedback Summary
                  </h1>
                  <p className="mt-0">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                </div>
                <div className="col-12 sm:col-4">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Employee Name
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputText
                      id="text"
                      disabled
                      placeholder="Name"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="col-12 sm:col-4">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Training Type
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputText
                      id="text"
                      disabled
                      placeholder="Training"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="col-12 sm:col-4">
                  <label
                    htmlFor="text"
                    className="font-bold block mb-2 training-heading"
                  >
                    Target Skill
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputText
                      id="text"
                      disabled
                      placeholder="Skills"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <label className="font-bold block mb-2 training-heading">
                    Business Outcome Met
                  </label>
                  <Checkbox
                    inputId="businessOutcomeMet"
                    onChange={(e) => setBusiness(e.target.checked)}
                    checked={business}
                  />
                </div>
                <div className="col-12">
                  <label className="font-bold block mb-2 training-heading">
                    Expected Skill Level Achieved
                  </label>
                  <Checkbox
                    inputId="expectedSkillLevelAchieved"
                    onChange={(e) => setChecked(e.checked)}
                    checked={checked}
                  />
                </div>
                <div className="col-12">
                  <label
                    htmlFor="comments"
                    className="font-bold block mb-2 training-heading"
                  >
                    Comments <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="p-inputgroup flex-1">
                    <InputTextarea
                      id="comments"
                      placeholder="Enter comments"
                      rows={3}
                      className="w-full"
                      required
                      style={{ background: "#fff" }}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <button
                    aria-label="submit"
                    class="p-button p-component p-button-primary mt-2"
                    type="submit"
                    data-pc-name="button"
                    data-pc-section="root"
                  >
                    <span
                      class="p-button-icon p-c p-button-icon-left pi pi-check"
                      data-pc-section="icon"
                    ></span>
                    <span
                      className="p-button-label p-c"
                      data-pc-section="label"
                    >
                      Submit{" "}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
